import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";
import { useNotificationStyles } from "./notificationStyles";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

export function NotificationHeader({
  selectedButton,
  setSelectedButton,
  organizerUnreadMessages = 0,
  challengerUnreadMessages = 0,
  watchingUnreadMessages = 0,
}) {
  const deviceSize = useDeviceSize();


  return (
    <View
      style={{
        flexDirection:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? "column"
            : "row",
        justifyContent: "space-between",
        marginHorizontal: 15,
        gap: DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? 15 : null,
      }}
    >
      <Text
        style={[
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? AppFontStyle.BOLD_ANYBODY_23
            : AppFontStyle.BOLD_ANYBODY_32,
        ]}
      >
        Challenge Alerts list
      </Text>
      <View
        style={[
          {
            flexDirection: "row",
            gap: 13.85,
            alignSelf: "center",
          },
        ]}
      >
        <HeaderButton
          label="I've Organised"
          selectedButton={selectedButton}
          setSelectedButton={setSelectedButton}
          unreadMessages={organizerUnreadMessages}
        />
        <HeaderButton
          label="Challenges"
          selectedButton={selectedButton}
          setSelectedButton={setSelectedButton}
          unreadMessages={challengerUnreadMessages}
        />
        <HeaderButton
          label="Im Watching"
          selectedButton={selectedButton}
          setSelectedButton={setSelectedButton}
          unreadMessages={watchingUnreadMessages}
        />
      </View>
    </View>
  );
}

function HeaderButton({
  label,
  selectedButton,
  setSelectedButton,
  unreadMessages,
}) {
  const deviceSize = useDeviceSize();
  const styles = useNotificationStyles();

  return (
    <TouchableOpacity
      style={[
        styles.iveOrganizedButtonStyle,
        {
          position: "relative",
          backgroundColor: AppColors.blackTrans_000000a8,
          paddingHorizontal:
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 25 : 15,
          paddingVertical: 12,
          borderColor:
            selectedButton === label ? "white" : AppColors.gary_4E4E4E,
        },
      ]}
      onPress={() => {
        setSelectedButton(label);
      }}
    >
      <Text
        style={[
          AppFontStyle.BOLD_ANYBODY_12,
          {
            color: selectedButton === label ? "white" : AppColors.gary_4E4E4E,
          },
        ]}
      >
        {label}
      </Text>

      {/* Show badge when has unread notifications (isSeen: 0) - always visible */}
      {unreadMessages > 0 && (
        <View
          style={{
            position: "absolute",
            right: -5,
            top: -5,
            backgroundColor: '#DC2626',
            borderRadius: 12,
            minWidth: 19,
            height: 19,
            paddingHorizontal: 4,
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
            borderWidth: 1,
            borderColor: AppColors.white,
          }}
        >
          <Text
            style={{
              color: AppColors.white,
              fontSize: 10,
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            {unreadMessages > 99 ? '99+' : unreadMessages}
          </Text>
        </View>
      )}
    </TouchableOpacity>
  );
}

export default NotificationHeader;
